import styles from './ProjectsTabPage.module.css';

import { observer } from 'mobx-react-lite';
import ListNavigationDrawer from '../../../widgets/ListNavigationDrawer';
import { useCallback, useEffect, useRef, useState } from 'react';
import { projectsStore } from '../../../store/mobx/projects.store';
import UpsertProjectModal from './UpsertProjectModal/index';
import ViewEditProject from './ViewEditProject';
import { productionStore } from 'store/mobx/production.store';

const ProjectsTabPage = observer(() => {
  const { projects, setProjects, setSelectedProject, selectedProject, isLoading } = projectsStore;
  const { reset } = productionStore;

  const listNavigationRef = useRef(null);
  const [projectModalOpened, setProjectModalOpened] = useState(false);
  const [viewEditProjectOpened, setViewEditProjectOpened] = useState(false);

  const actions = [
    {
      name: 'Новый проект',
      callback: () => createProject(),
    },
  ];

  useEffect(() => {
    setViewEditProjectOpened(!!selectedProject?.id);
  }, [selectedProject?.id]);

  const createProject = useCallback(async () => {
    setSelectedProject(null);
    listNavigationRef.current.resetSelected();
    setProjectModalOpened(true);
  }, []);

  const refreshProjects = useCallback((expandedGroups, { search = undefined } = {}) => {
    setProjects({ search });
  }, []);

  const handleSelectProject = async (id) => {
    setSelectedProject(id ? { id: id } : null);
    reset();
  };

  return (
    <div className={styles.pageContainer}>
      <ListNavigationDrawer
        ref={listNavigationRef}
        actionsCallbacks={actions}
        resetGroup={() => {}}
        items={projects}
        isLoading={isLoading}
        onUpdate={refreshProjects}
        onSelect={handleSelectProject}
        initialFirstPaneSize={25}
      >
        {viewEditProjectOpened && <ViewEditProject />}
      </ListNavigationDrawer>
      {projectModalOpened && <UpsertProjectModal setModalOpened={setProjectModalOpened} />}
    </div>
  );
});

export default ProjectsTabPage;
